var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import PropTypes from 'prop-types';
import adminCustomers from '../../../icons/admin-customers.svg';
import aiIcon from '../../../icons/ai.svg';
import arrowNextStep from '../../../icons/arrow-next-step.svg';
import navigationArrow from '../../../icons/arrow-right.svg';
import arrowRightGreen from '../../../icons/arrow-right-green.svg';
import arrowUp from '../../../icons/arrow-up.svg';
import autopay from '../../../icons/autopay.svg';
import back from '../../../icons/back.svg';
import bank from '../../../icons/bank.svg';
import banknote from '../../../icons/banknote.svg';
import blockClient from '../../../icons/block-client.svg';
import bold from '../../../icons/bold.svg';
import brandPointsOnMap from '../../../icons/brand-points-on-map.svg';
import capital from '../../../icons/capital.svg';
import capitalV2 from '../../../icons/capital-v2.svg';
import checkMark from '../../../icons/check-mark.svg';
import checkMarkBlue from '../../../icons/check-mark-blue.svg';
import checked from '../../../icons/checked.svg';
import chevronDropdown from '../../../icons/chevron-dropdown.svg';
import chevronLeft from '../../../icons/chevron-left.svg';
import chevronLeftBold from '../../../icons/chevron-left-bold.svg';
import chevronRight from '../../../icons/chevron-right.svg';
import clock from '../../../icons/clock.svg';
import clone from '../../../icons/clone.svg';
import close from '../../../icons/close.svg';
import closeBtn from '../../../icons/close-btn.svg';
import closeSmall from '../../../icons/close-small.svg';
import concierge from '../../../icons/concierge.svg';
import creditCard from '../../../icons/credit-card.svg';
import cardsLedger from '../../../icons/credit-card-ledger.svg';
import crossSign from '../../../icons/cross-sign.svg';
import dashboard from '../../../icons/dashboard.svg';
import discount from '../../../icons/discount.svg';
import discounts from '../../../icons/discounts.svg';
import dollar from '../../../icons/dollar.svg';
import dollarCircle from '../../../icons/dollar-circle.svg';
import dollarCircleBalloon from '../../../icons/dollar-circle-balloon.svg';
import download from '../../../icons/download.svg';
import editSmall from '../../../icons/edit.svg';
import email from '../../../icons/email.svg';
import email2 from '../../../icons/email2.svg';
import emailThick from '../../../icons/email-thick.svg';
import engagement from '../../../icons/engagement.svg';
import exclamation from '../../../icons/exclamation.svg';
import exclamationCircle from '../../../icons/exclamation-circle.svg';
import forbidden from '../../../icons/forbidden.svg';
import giftCard from '../../../icons/gift-card.svg';
import groupAppointment from '../../../icons/group-appointment.svg';
import hourglass from '../../../icons/hourglass.svg';
import addPhoto from '../../../icons/icon-add_photo.svg';
import analytics from '../../../icons/icon-analytics.svg';
import arrow from '../../../icons/icon-arrow.svg';
import arrowLeft from '../../../icons/icon-arrow-left.svg';
import arrowLeftLight from '../../../icons/icon-arrow-left-light.svg';
import arrowRight from '../../../icons/icon-arrow-right.svg';
import arrowRightLight from '../../../icons/icon-arrow-right-light.svg';
import arrowCircle from '../../../icons/icon-arrow_circle.svg';
import arrowXClose from '../../../icons/icon-arrow_x_close.svg';
import arrowXCloseSmall from '../../../icons/icon-arrow_x_close_small.svg';
import barbers from '../../../icons/icon-barbers-new.svg';
import appointment from '../../../icons/icon-calendar-new.svg';
import cancel from '../../../icons/icon-cancel.svg';
import cashregister from '../../../icons/icon-cashregister-new.svg';
import chartArrowUp from '../../../icons/icon-chart-arrow-up.svg';
import check from '../../../icons/icon-check.svg';
import coin from '../../../icons/icon-coin.svg';
import customers from '../../../icons/icon-customers-new.svg';
import deleteIcon from '../../../icons/icon-delete.svg';
import dragDrop from '../../../icons/icon-drag_drop.svg';
import edit from '../../../icons/icon-edit.svg';
import facebook from '../../../icons/icon-facebook.svg';
import globe from '../../../icons/icon-globe.svg';
import help from '../../../icons/icon-help-new.svg';
import infoIcon from '../../../icons/icon-info.svg';
import instagram from '../../../icons/icon-instagram.svg';
import more from '../../../icons/icon-more.svg';
import notification from '../../../icons/icon-notification.svg';
import packages from '../../../icons/icon-package-new.svg';
import piechartOneFifth from '../../../icons/icon-piechart-onefifth-filled.svg';
import plus from '../../../icons/icon-plus.svg';
import recoverSuccess from '../../../icons/icon-recover-success.svg';
import refresh from '../../../icons/icon-refresh.svg';
import remove from '../../../icons/icon-remove.svg';
import sandTimer from '../../../icons/icon-sandtimer.svg';
import save from '../../../icons/icon-save.svg';
import search from '../../../icons/icon-search.svg';
import services from '../../../icons/icon-services-new.svg';
import settings from '../../../icons/icon-settings-new.svg';
import shop from '../../../icons/icon-shop.svg';
import spinner from '../../../icons/icon-spinner.svg';
import twitter from '../../../icons/icon-twitter.svg';
import warning from '../../../icons/icon-warning.svg';
import workhours from '../../../icons/icon-workhours.svg';
import cross from '../../../icons/icon-x.svg';
import xTag from '../../../icons/icon-x_tag.svg';
import identityCard from '../../../icons/identity-card.svg';
import info from '../../../icons/info.svg';
import infoCircled from '../../../icons/info-circled.svg';
import languageGlobe from '../../../icons/language-globe.svg';
import membershipsCancel from '../../../icons/memberships-cancel.svg';
import membershipsCopy from '../../../icons/memberships-copy.svg';
import membershipsEdit from '../../../icons/memberships-edit.svg';
import membershipsOptions from '../../../icons/memberships-options.svg';
import membershipsPause from '../../../icons/memberships-pause.svg';
import memberships from '../../../icons/memberships-star.svg';
import membershipsStart from '../../../icons/memberships-start.svg';
import membershipsView from '../../../icons/memberships-view.svg';
import message from '../../../icons/message.svg';
import messageRound from '../../../icons/message-round.svg';
import monitor from '../../../icons/monitor.svg';
import open from '../../../icons/open.svg';
import paymentCardAmex from '../../../icons/payment-card-amex.svg';
import paymentCardDiners from '../../../icons/payment-card-diners.svg';
import paymentCardDiscover from '../../../icons/payment-card-discover.svg';
import paymentCardJcb from '../../../icons/payment-card-jcb.svg';
import paymentCardMastercard from '../../../icons/payment-card-mastercard.svg';
import paymentCardUnionpay from '../../../icons/payment-card-unionpay.svg';
import paymentCardUnknown from '../../../icons/payment-card-unknown.svg';
import paymentCardVisa from '../../../icons/payment-card-visa.svg';
import phone from '../../../icons/phone.svg';
import play from '../../../icons/play.svg';
import plusSign from '../../../icons/plus-sign.svg';
import pointOnMap from '../../../icons/point-on-map.svg';
import question from '../../../icons/question.svg';
import referral from '../../../icons/referral-sidebar.svg';
import rename from '../../../icons/rename.svg';
import reports from '../../../icons/reports-new.svg';
import rewrite from '../../../icons/rewrite.svg';
import selectedShopMark from '../../../icons/selected-shop-mark.svg';
import shopifyLogo from '../../../icons/shopify-logo.svg';
import slack from '../../../icons/slack-new-logo 3.svg';
import clockProgress from '../../../icons/sr-clock-progress.svg';
import warningHexagon from '../../../icons/sr-warning-hexagon.svg';
import stop from '../../../icons/stop.svg';
import stopwatch from '../../../icons/stopwatch-new.svg';
import supply from '../../../icons/supply.svg';
import team from '../../../icons/team.svg';
import textAlignMiddle from '../../../icons/textAlignMiddle.svg';
import textParagraphSpacing from '../../../icons/textParagraphSpacing.svg';
import trash from '../../../icons/trash.svg';
import twoFaIcon from '../../../icons/two-fa-icon.svg';
import twoFaKey from '../../../icons/two-fa-key.svg';
import upload from '../../../icons/upload.svg';
import warningRound from '../../../icons/warning-round.svg';
import warningTriangle from '../../../icons/warning-triangle.svg';
export var GLYPHS = {
    addPhoto: addPhoto,
    aiIcon: aiIcon,
    appointment: appointment,
    arrow: arrow,
    arrowLeft: arrowLeft,
    arrowLeftLight: arrowLeftLight,
    arrowRight: arrowRight,
    arrowRightLight: arrowRightLight,
    arrowUp: arrowUp,
    arrowCircle: arrowCircle,
    arrowXClose: arrowXClose,
    arrowXCloseSmall: arrowXCloseSmall,
    arrowNextStep: arrowNextStep,
    barbers: barbers,
    calendar: appointment,
    cancel: cancel,
    check: check,
    customers: customers,
    delete: deleteIcon,
    dragDrop: dragDrop,
    edit: edit,
    facebook: facebook,
    twitter: twitter,
    info: info,
    infoCircled: infoCircled,
    twoFaIcon: twoFaIcon,
    instagram: instagram,
    globe: globe,
    more: more,
    notification: notification,
    plus: plus,
    cross: cross,
    refresh: refresh,
    save: save,
    search: search,
    services: services,
    settings: settings,
    shop: shop,
    spinner: spinner,
    workhours: workhours,
    xTag: xTag,
    remove: remove,
    rewrite: rewrite,
    packages: packages,
    cashregister: cashregister,
    close: close,
    play: play,
    stop: stop,
    stopwatch: stopwatch,
    chevronLeft: chevronLeft,
    chevronRight: chevronRight,
    dashboard: dashboard,
    analytics: analytics,
    dollar: dollar,
    creditCard: creditCard,
    discount: discount,
    bank: bank,
    adminCustomers: adminCustomers,
    twoFaKey: twoFaKey,
    textParagraphSpacing: textParagraphSpacing,
    textAlignMiddle: textAlignMiddle,
    message: message,
    messageRound: messageRound,
    email: email,
    emailThick: emailThick,
    email2: email2,
    forbidden: forbidden,
    help: help,
    closeBtn: closeBtn,
    checkMark: checkMark,
    checkMarkBlue: checkMarkBlue,
    upload: upload,
    closeSmall: closeSmall,
    engagement: engagement,
    banknote: banknote,
    back: back,
    editSmall: editSmall,
    trash: trash,
    open: open,
    chevronLeftBold: chevronLeftBold,
    giftCard: giftCard,
    autopay: autopay,
    arrowRightGreen: arrowRightGreen,
    chevronDropdown: chevronDropdown,
    reports: reports,
    bold: bold,
    team: team,
    clone: clone,
    monitor: monitor,
    discounts: discounts,
    supply: supply,
    capital: capital,
    capitalV2: capitalV2,
    recoverSuccess: recoverSuccess,
    warning: warning,
    concierge: concierge,
    dollarCircle: dollarCircle,
    dollarCircleBalloon: dollarCircleBalloon,
    cardsLedger: cardsLedger,
    coin: coin,
    chartArrowUp: chartArrowUp,
    sandTimer: sandTimer,
    piechartOneFifth: piechartOneFifth,
    warningHexagon: warningHexagon,
    clockProgress: clockProgress,
    slack: slack,
    download: download,
    navigationArrow: navigationArrow,
    membershipsEdit: membershipsEdit,
    membershipsView: membershipsView,
    membershipsCopy: membershipsCopy,
    membershipsStart: membershipsStart,
    membershipsPause: membershipsPause,
    membershipsCancel: membershipsCancel,
    membershipsOptions: membershipsOptions,
    identityCard: identityCard,
    memberships: memberships,
    blockClient: blockClient,
    exclamation: exclamation,
    exclamationCircle: exclamationCircle,
    shopifyLogo: shopifyLogo,
    hourglass: hourglass,
    pointOnMap: pointOnMap,
    selectedShopMark: selectedShopMark,
    brandPointsOnMap: brandPointsOnMap,
    infoIcon: infoIcon,
    languageGlobe: languageGlobe,
    plusSign: plusSign,
    crossSign: crossSign,
    warningTriangle: warningTriangle,
    warningRound: warningRound,
    question: question,
    paymentCardAmex: paymentCardAmex,
    paymentCardDiners: paymentCardDiners,
    paymentCardDiscover: paymentCardDiscover,
    paymentCardJcb: paymentCardJcb,
    paymentCardMastercard: paymentCardMastercard,
    paymentCardUnionpay: paymentCardUnionpay,
    paymentCardUnknown: paymentCardUnknown,
    paymentCardVisa: paymentCardVisa,
    groupAppointment: groupAppointment,
    referral: referral,
    checked: checked,
    clock: clock,
    rename: rename,
    phone: phone,
};
var Icon = function (_a) {
    var glyph = _a.glyph, size = _a.size, className = _a.className, onClick = _a.onClick, otherProps = __rest(_a, ["glyph", "size", "className", "onClick"]);
    var classes = classnames('o-icon', {
        'o-icon--large': size === 'large',
        'o-icon--medium': size === 'medium',
        'o-icon--tiny': size === 'small',
        'o-icon--micro': size === 'micro',
        'o-icon--nano': size === 'nano',
        'o-icon--calendar': size === 'calendar',
    }, className);
    var ImageComponent = glyph;
    return _jsx(ImageComponent, __assign({ role: "img", className: classes, onClick: onClick }, otherProps));
};
Icon.propTypes = {
    glyph: PropTypes.shape({ id: PropTypes.string }).isRequired,
    size: PropTypes.oneOf(['large', 'medium', 'small', 'micro', 'nano', 'calendar']),
    className: PropTypes.string,
    onClick: PropTypes.func,
};
Icon.defaultProps = {
    size: null,
    className: '',
    onClick: undefined,
};
export default Icon;
